import React, { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import styled from "styled-components";
import { SelectedDeviceSelector } from "../redux/selector";
import { Form, Button, Schema, Breadcrumb, Col, Row } from "rsuite";
import { handleSendSms, Patterns } from "../scripts/helper";
import ArrowLeftLineIcon from "@rsuite/icons/ArrowLeftLine";

const Container = styled.div`
  width: 100%;
`;

class AddSimComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formValue: {
        num1: "",
        num2: "",
      },
    };
    this.formRef = React.createRef();
  }

  handleSubmit = () => {
    const { handleBack, selectedDevice } = this.props;
    const { formValue } = this.state;
    if (this.formRef.current.check()) {
      let smsWord;
      if (!!formValue.num2) {
        smsWord = `${formValue.num1}.${formValue.num2}`;
      } else {
        smsWord = `${formValue.num1}`;
      }
      handleSendSms(smsWord, selectedDevice);
      handleBack();
    }
  };

  render() {
    const { handleBack } = this.props;
    const { formValue } = this.state;
    const { StringType, NumberType } = Schema.Types;

    const model = Schema.Model({
      num1: StringType()
        .isRequired("اجباری")
        .pattern(Patterns.mobile, "شماره نامعتبر"),
      num2: NumberType().pattern(Patterns.mobile, "شماره نامعتبر"),
    });
    return (
      <Container>
        <Breadcrumb separator={<ArrowLeftLineIcon />}>
          <Breadcrumb.Item
            style={{ color: "#f07d00" }}
            onClick={() => handleBack()}
          >
            تنظیمات
          </Breadcrumb.Item>
          <Breadcrumb.Item>افزودن سیمکارت</Breadcrumb.Item>
        </Breadcrumb>
        <Form
          autoComplete="off"
          formValue={formValue}
          onChange={(formValue) => this.setState({ formValue })}
          model={model}
          fluid
          ref={this.formRef}
        >
          <Form.Group>
            <Form.ControlLabel>شماره خط اول همراه مالک</Form.ControlLabel>
            <Form.Control
              name="num1"
              placeholder="09..."
              style={{ direction: "ltr" }}
              type="number"
            />
          </Form.Group>
          <Form.Group>
            <Form.ControlLabel>شماره خط دوم همراه مالک</Form.ControlLabel>
            <Form.Control
              name="num2"
              placeholder="09..."
              style={{ direction: "ltr" }}
              type="number"
            />
          </Form.Group>
          <Row>
            <Col xs={12}>
              <Button
                size="sm"
                block
                appearance="primary"
                type="submit"
                onClick={() => this.handleSubmit()}
                color="orange"
              >
                ثبت
              </Button>
            </Col>
            <Col xs={12}>
              <Button size="sm" block onClick={() => handleBack()}>
                لغو
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  selectedDevice: SelectedDeviceSelector,
});

export default connect(mapStateToProps)(AddSimComponent);
